import React from 'react';
import PropTypes from 'prop-types';
import { emptyArray } from 'ui-components/default-props/empty';
import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import { noop } from 'ui-components/default-props/noop';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { FormattedMessage } from 'react-intl';
import { ACCOUNT } from '../../../../../enums/bill-to-party';
import style from '../../common-styles.module.less';
import { messages } from './messages';

const defaultCriteriaInformation = {
  criterionStateMethods: {
    getCriterionMeta: noop,
    updateCriterionMeta: noop,
    getCriterionArgument: noop,
    updateCriterionArgument: noop,
  },
  criterionArgumentOptions: emptyArray,
};

export const ShippingAccountComponent = ({ criteriaInformations = defaultCriteriaInformation }) => {
  const { criterionStateMethods, criterionArgumentOptions } = criteriaInformations;
  const { getCriterionMeta, updateCriterionMeta, getCriterionArgument, updateCriterionArgument } = criterionStateMethods;
  const selectedCriterionArgument = getCriterionArgument();
  const selectedCriterion = selectedCriterionArgument && selectedCriterionArgument.value ? selectedCriterionArgument : '';
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const providers = useSelector(Global.selectReferenceDatagetProviders);
  const shippingAccountOptionTypes = Object.keys(messages);
  const selectedOptionType = getCriterionMeta()?.value || shippingAccountOptionTypes[0];
  const selectedTypeDisplay = <FormattedMessage {...messages[selectedOptionType]} />;

  const setShippingAccountSellerProviderId = (shippingAccount) => {
    if (shippingAccount) {
      return updateCriterionArgument(shippingAccount);
    }
    updateCriterionArgument(null);
  };

  const getSellerLabelProviderName = () => {
    const displayName = [];
    sellerLabelProviders.forEach((labelProvider) => {
      providers.forEach((provider) => {
        if (provider.labelProviderId === labelProvider.labelProviderId) {
          const accountNickname =
            labelProvider.name && !labelProvider.useHouseCredentials ? `${provider.name} - (${labelProvider.name})` : provider.name;
          displayName.push({
            provider: accountNickname,
            name: accountNickname,
            id: labelProvider.sellerLabelProviderId,
          });
        }
      });
    });
    return displayName;
  };

  const displaySellerLabelProviders = getSellerLabelProviderName();

  return (
    <div className={style['form-criteria-section']}>
      <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler>{selectedTypeDisplay}</DropdownMenuToggler>
        {shippingAccountOptionTypes.map((option) => (
          <DropdownMenuItem
            key={option}
            onClick={() => {
              updateCriterionMeta({ value: option });
              if (option === ACCOUNT) {
                setShippingAccountSellerProviderId(criterionArgumentOptions[0]);
                return;
              }
              // if it's not My Account, we want to null out the seller provider ID and say which billToProvider user selected
              setShippingAccountSellerProviderId(null);
            }}
            selected={option === selectedOptionType}
          >
            <FormattedMessage {...messages[option]} />
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
      {selectedOptionType === ACCOUNT && (
        <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
          <DropdownMenuToggler>{selectedCriterion.displayName}</DropdownMenuToggler>
          {criterionArgumentOptions.map((option, i) => {
            return (
              <DropdownMenuItem
                key={displaySellerLabelProviders[i].name}
                onClick={() => setShippingAccountSellerProviderId(option)}
                selected={displaySellerLabelProviders[i].id === selectedCriterion.value}
              >
                {displaySellerLabelProviders[i]?.name}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      )}
    </div>
  );
};

ShippingAccountComponent.propTypes = {
  criteriaInformations: PropTypes.shape({
    criterionStateMethods: PropTypes.shape({
      getCriterionMeta: PropTypes.func,
      updateCriterionMeta: PropTypes.func,
      getCriterionArgument: PropTypes.func,
      updateCriterionArgument: PropTypes.func,
    }),
    criterionArgumentOptions: PropTypes.array,
  }),
};
